// extracted by mini-css-extract-plugin
var _1 = "DocFlow-modulenotification__Duwmm";
var _2 = "DocFlow-modulenotificationSkeleton__GtvRl Skeleton-moduleSkeleton__Mlrfv";
var _3 = "DocFlow-modulenotifications__CM4iC";
var _4 = "DocFlow-modulescrollWrapper__JBP58 PageWithWidgets-modulescrollWrapper__X6x9d";
var _5 = "DocFlow-modulewithModalsTray__tGNKL";
var _6 = "DocFlow-modulewithSupportButtons__Gi87e";
export { _1 as "notification", _2 as "notificationSkeleton", _3 as "notifications", _4 as "scrollWrapper", _5 as "withModalsTray", _6 as "withSupportButtons" }
